import { connect } from "react-redux"
import React, { Component } from "react"

import type { Role } from "../../types/types"
import { evidenceListRequest } from "../../actions/evidence-actions"
import NewRoleBlock from "../stakeholders/stakeholder-item/edit/NewRoleBlock"
import StakeholderRelationshipEditRoleBlock from "./StakeholderRelationshipEditRoleBlock"

type Props = {
    roles: Array<Role>,
    stakeholderType: string,
    getEvidence: string => void
}

type State = { isExpandedIndex: number }

class StakeholderRelationshipsEditWidget extends Component<Props, State> {
    state = {
        isExpandedIndex: -1
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.roles.length < nextProps.roles.length) {
            this.setState({
                isExpandedIndex:
                    this.state.isExpandedIndex === -1
                        ? -1
                        : this.state.isExpandedIndex + 1
            })
        }
    }

    toggleEvidence = index => roleID => () => {
        const toBeExpandedIndex =
            index === this.state.isExpandedIndex ? -1 : index

        // if opening an evidence block (aka toBeExpandedIndex is a positive
        // integer), request evidence
        if (toBeExpandedIndex !== -1) {
            this.props.getEvidence(roleID)
        }

        this.setState({
            isExpandedIndex: toBeExpandedIndex
        })
    }

    render() {
        const { isExpandedIndex } = this.state
        const { stakeholderType, roles } = this.props

        return (
            <div className="widget">
                <h3 className="widget-header">
                    <i className="icon icon-concepts" />Relationships
                </h3>
                <div className="widget-content">
                    <NewRoleBlock stakeholderType={stakeholderType} />
                    {roles &&
                        roles
                            .filter(role => role.saveStatus !== "DELETE")
                            .map((role, index) => (
                                <StakeholderRelationshipEditRoleBlock
                                    key={index}
                                    role={role}
                                    stakeholderType={stakeholderType}
                                    isExpanded={isExpandedIndex === index}
                                    toggleEvidence={this.toggleEvidence(index)}
                                />
                            ))}
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ presentation: { roles }, entities }) => ({
    roles: roles.edit.map(role => entities.roles[role])
})

const mapDispatchToProps = dispatch => ({
    getEvidence: roleID => dispatch(evidenceListRequest(roleID))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    StakeholderRelationshipsEditWidget
)
